export default {
  resetOrderForm(state) {
    state.orderForm = {
      order_number: '',
      sales_channel: '',
      quote_id: null,
      scheduled: false,
      shipment_order_type: 'RETURN',
      shipment_order_sub_type: 'PICKUP',
      estimated_delivery_date: null,
      scheduled_delivery_date: null,
      invoice_total_value: 0.0,
      provider_shipping_costs: 0.0,
      first_name: '',
      last_name: '',
      email: '',
      federal_tax_payer_id: '',
      phone: '',
      cellphone: '',
      shipping_address: '',
      shipping_number: '',
      shipping_additional: '',
      shipping_reference: '',
      shipping_quarter: '',
      shipping_city: '',
      shipping_zip_code: '',
      shipping_state: '',
      shipping_state_code: '',
      shipping_country: '',
      delivery_information: {},
      shipment_order_volume_array: [],
    };
  },
  setActiveStep(state, activeStep) {
    state.activeStep = activeStep;
  },
  setOrder(state, order) {
    state.order = order;
  },
  setOrderForm(state, orderForm) {
    state.orderForm = orderForm;
  },
  setOrderFormDeliveryInfo(state, deliveryInfo) {
    state.orderForm = Object.assign(state.orderForm, { delivery_information: deliveryInfo });
  },
  setOrderVolumeArray(state, volumeArray) {
    state.orderForm.shipment_order_volume_array = volumeArray;
  },
  setOrderQuoteInfo(state, quoteInfo) {
    state.orderForm = Object.assign(state.orderForm, {
      quote_id: quoteInfo.quoteId,
      delivery_method_id: quoteInfo.id,
      delivery_method_external_id: quoteInfo.id,
      customer_shipping_costs: quoteInfo.final_shipping_cost,
      provider_shipping_costs: quoteInfo.cost,
    });
  },
  setQuoteInfo(state, quoteInfo) {
    state.quoteInfo = quoteInfo;
  },
  setSeller(state, seller) {
    state.orderForm.seller = seller;
  },
  setSellers(state, sellers) {
    state.sellers = [sellers];
  },
  setVolumeOrItem(state, volOrItem) {
    state.volumeOrItem = volOrItem;
  },
  toggleLoading(state, loading) {
    state.loading = loading;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/features/create-reverse/store/mutations.js